import styled from 'styled-components';
import { Drawer as MUIDrawer } from '@material-ui/core';

export const Drawer = styled(MUIDrawer)`
${({
  theme: {
    colors
  },
}) => `
  & > .MuiDrawer-paper {
    background-color: ${colors.greens.green3};
    width: 100%;

    padding: 20px 20px 72px;
  }
`}
`;
